module.exports = __webpack_public_path__ + "static/media/vaillant-logo.4cbd3419.jpg";